export const REQUEST_CREATE_ANNOUNCEMENT = 'announcement/REQUEST_CREATE_ANNOUNCEMENT';
